import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTranslation } from "../../../../../translation";
import { getLocation } from "../../../../../../state/modules/router/selectors";
import { changeSort } from "../../../../../../state/modules/search/actions";
import { getPageName } from "../../../../../../state/modules/page/selectors";
import styles from "./index.css";

export const SmallScreenSort = ({ formatTranslation, showSortOverlay }) => (
  <div className={styles.container}>
    <button id="sortBy" className={styles.button} onClick={showSortOverlay}>
      {formatTranslation("plp_web_sort_sort")}
    </button>
  </div>
);

SmallScreenSort.displayName = "Sort";

SmallScreenSort.propTypes = {
  by: PropTypes.string,
  changeSort: PropTypes.func.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  pageName: PropTypes.string.isRequired,
  showSortOverlay: PropTypes.func.isRequired
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    by: getLocation(state).query.sort,
    pageName: getPageName(state)
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeSort
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(SmallScreenSort));
